import * as React from 'react';
import Svg from 'react-native-svg';
import { View } from 'react-native';
import Animated, { withTiming, interpolate, Extrapolation, useSharedValue, useAnimatedProps, useAnimatedStyle, Reanimated3DefaultSpringConfig, withSpring, } from 'react-native-reanimated';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { AnimatedPath } from 'design-system/AnimatedComponents';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
const VIEW_HEIGHT = rem(26);
const InitialPriceIndicatorView = ({ width, height, paddingTop, initialPoint, selectedInfoObj, }) => {
    const didMount = React.useRef(false);
    const styles = useStyles(styleSet);
    const colors = useColors();
    const xFlexSharedValue = useSharedValue(initialPoint?.centerAlign ? 1 : 0);
    const y = useSharedValue(initialPoint.y * height);
    React.useEffect(() => {
        if (didMount.current) {
            y.value = withTiming(initialPoint.y * height);
            const newXFlexValue = initialPoint?.centerAlign ? 1 : 0;
            xFlexSharedValue.value = withTiming(newXFlexValue);
        }
        else {
            didMount.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [height, initialPoint?.centerAlign, initialPoint.y]);
    const animatedLineProps = useAnimatedProps(() => {
        const props = {
            d: `M0 ${y.value} l${width} 0`,
        };
        return props;
    }, [width, y]);
    const animatedTextWrapperStyles = useAnimatedStyle(() => ({
        top: interpolate(y.value, [0, height / 2, height / 2 + 1, height], [y.value + 18, y.value + 18, y.value - VIEW_HEIGHT + 2, y.value - VIEW_HEIGHT + 2], Extrapolation.CLAMP),
    }), [height, y]);
    const translateXStyles = useAnimatedStyle(() => ({
        flex: xFlexSharedValue.value,
    }), [xFlexSharedValue]);
    const containerAnimatedStyles = useAnimatedStyle(() => ({
        opacity: withSpring(!selectedInfoObj.value ? 1 : 0, Reanimated3DefaultSpringConfig),
    }), [selectedInfoObj]);
    return (<Animated.View pointerEvents="none" style={[styles.container, { marginVertical: paddingTop }, containerAnimatedStyles]}>
      <Svg width={width} height={height + 20} viewBox={`0 0 ${width} ${height}`}>
        <AnimatedPath strokeWidth={1} strokeDasharray="1,5" animatedProps={animatedLineProps} stroke={colors.elements.secondary}/>
      </Svg>
      <Animated.View style={[styles.priceView, animatedTextWrapperStyles]}>
        <Animated.View style={translateXStyles}/>
        <View style={styles.textWrapper}>
          <Text NumbersThin-12 Secondary>
            {initialPoint.formattedPrice}
          </Text>
        </View>
        <View style={styles.flex}/>
      </Animated.View>
    </Animated.View>);
};
const InitialPriceIndicator = ({ width, height, paddingTop, initialPoint, selectedInfoObj, }) => {
    const didMount = React.useRef(false);
    const [privateInitialPoint, setPrivateInitialPoint] = React.useState(initialPoint);
    React.useEffect(() => {
        if (didMount.current) {
            if (initialPoint !== undefined) {
                setPrivateInitialPoint(initialPoint);
            }
        }
        else {
            didMount.current = true;
        }
    }, [initialPoint]);
    if (!privateInitialPoint) {
        return null;
    }
    return (<InitialPriceIndicatorView width={width} height={height} paddingTop={paddingTop} selectedInfoObj={selectedInfoObj} initialPoint={privateInitialPoint}/>);
};
export default React.memo(InitialPriceIndicator);
const styleSet = createStyleSheets((colors) => ({
    container: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        position: 'absolute',
    },
    textWrapper: {
        height: VIEW_HEIGHT,
        borderRadius: rem(4),
        justifyContent: 'center',
        paddingHorizontal: rem(6),
        // @ts-ignore
        backgroundColor: `${colors.background.dark}D9`,
    },
    priceView: {
        left: rem(6),
        right: rem(6),
        height: VIEW_HEIGHT,
        position: 'absolute',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
}));
